import { useEffect, useState } from "react";
import { api, fetchAll } from "@/lib/apiClient";
import { Card, CardContent } from "@/components/ui/card";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { fmtDateTime } from "@/lib/dates";

export function AdminLedger() {
  const [rows, setRows] = useState([]);
  useEffect(() => { fetchAll("/admin/failed-ledger").then(setRows).catch(() => {}); }, []);
  return (
    <div className="space-y-6" data-testid="admin-ledger-page">
      <h1 className="font-serif-display text-3xl md:text-4xl text-white">Failed Transactions Ledger</h1>
      <Card><CardContent className="p-0"><Table>
        <TableHeader><TableRow><TableHead>Timestamp</TableHead><TableHead>User</TableHead><TableHead>Step</TableHead><TableHead>Reason</TableHead></TableRow></TableHeader>
        <TableBody>
          {rows.map(r => (<TableRow key={r.id}><TableCell className="text-xs">{fmtDateTime(r.ts)}</TableCell><TableCell className="font-mono text-xs">{r.user_id?.slice(0,8)}</TableCell><TableCell>{r.step}</TableCell><TableCell className="text-xs text-[#F27373]">{r.reason}</TableCell></TableRow>))}
          {rows.length===0 && <TableRow><TableCell colSpan={4} className="text-center text-[#6B7280] py-10">No failures logged. All systems nominal.</TableCell></TableRow>}
        </TableBody>
      </Table></CardContent></Card>
    </div>
  );
}
